<template>
    <div class="FFoldBox" :class="{screenFFBox:type==='screen'}">
        <div class="FFoldBox-header" @click="foldClick" :class="{active:active}">
            <span>{{name||'name'}}</span>
            <i class="el-icon-arrow-down" :class="{active:!onOff}"></i>
        </div>
        <div class="fold-concat" v-show="!onOff">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props: {
            name: {
                type: String,
                default: '未命名'
            },
            show: {
                type: Boolean,
                default: true
            },
            active: {
                type: Boolean,
            },
            type: {
                type: String,
                default: 'view'
            }
        },
        data() {
            return {
                onOff: this.show
            }
        },
        methods: {
            foldClick() {
                this.onOff = !this.onOff;
            }
        },
        mounted() {

        }
    }
</script>

<style lang="less">
    .FFoldBox {
        margin: 5px 0 0;
        display: inline-block;
        width: 100%;

        .FFoldBox-header {
            width: 100%;
            line-height: 35px;
            padding: 0 10px;
            letter-spacing: 2px;
            font-weight: bold;
            background-color: #eeeeee;
            color: @fontColor;

            > span, > i {
                color: @fontColor;
            }

            > i {
                margin-right: 5px;
                display: inline-block;
                font-size: 14px;
                transition: 0.3s all ease;
                font-weight: bold;
                cursor: pointer;
                float: right;
                transform: rotate(-90deg);
                margin-top: 17px;
            }

            > i.active {
                cursor: pointer;
                transform: rotate(0deg);
                vertical-align: middle;
            }

            > span {
                display: inline-block;
                color: @fontColor;
                font-size: 14px;
            }
        }
    }

    .screenFFBox {
        .FFoldBox-header {
            background-color: rgba(0, 39, 116, 0.25);
            color: #000;

            > span, > i {
                color: #000;
            }
        }

    }

    .FFoldBox:last-child {
        margin-bottom: 10px;
    }
</style>
